"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var slot = __importStar(require("./Slot"));
var title = __importStar(require("./Title"));
var entitlements = __importStar(require("./Entitlements"));
var hero = __importStar(require("./Hero"));
var analytics = __importStar(require("./Analytics"));
var pagination = __importStar(require("./Pagination"));
exports.default = {
    slot: slot,
    title: title,
    entitlements: entitlements,
    hero: hero,
    analytics: analytics,
    pagination: pagination,
};
//# sourceMappingURL=index.js.map